import { AppLink } from 'types/AppLink';
import { filterNotNull } from 'utils/array';
import { featureToggles } from 'utils/featureToggles';

import * as urls from './urls';

export const MAIN_NAVIGATION: AppLink[] = [
  { href: urls.getIndexUrl(), text: 'Home', isNewTab: false },
  { href: urls.getAboutUsUrl(), text: 'About Us', isNewTab: true },
  { href: urls.getPeopleUrl(), text: 'People', isNewTab: true },
  featureToggles.DEIPages
    ? {
        href: urls.getDEIUrl(),
        text: 'Diversity, Equity and Inclusion',
        isNewTab: false,
      }
    : null,
  { href: urls.getSustainabilityUrl(), text: 'Sustainability', isNewTab: true },
  { href: urls.getInvestorsUrl(), text: 'Investor Relations', isNewTab: false },
  { href: urls.getPressAndMediaUrl(), text: 'Press and Media', isNewTab: true },
  {
    href: urls.getFoundationUrl(),
    text: 'Hurtigruten Foundation',
    isNewTab: true,
  },
].filter(filterNotNull);

export const GO_TO_LINKS: AppLink[] = [
  {
    href: 'https://www.hurtigruten.com/destinations/',
    text: 'Hurtigruten Expeditions',
  },
  {
    href: 'https://www.hurtigruten.com/destinations/norway/',
    text: 'Hurtigruten Norwegian Coastal Express',
  },
  {
    href: 'https://hurtigrutensvalbard.com/en',
    text: 'Hurtigruten Svalbard',
  },
];
